module.exports = __webpack_public_path__ + "comp-vector.png?d16be8db648f0333c3ec597415e19776";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/comp-vector.png
// module id = 137
// module chunks = 0